import React from 'react';
import { resetPWGetUser, resetPassword } from 'actions/authentication'
import { connect } from 'react-redux';
import { Link } from 'react-router';
import toastr from "toastr"

class ResetPasswordForm extends React.Component {

  constructor() {
    super();
    this.submit = this.submit.bind(this);
    this.displayName = 'LoginPage'
    this.state = {
      new: '',
      new2: ''
    }
  }

  componentDidMount() {
    var key = this.props.location.query.k;
    this.props.dispatch(resetPWGetUser(key));
  }

  handleChange(e) {
    let key = e.target.id;
    let value = e.target.value;
    this.setState({ [key]: value });
  }

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.submit();
    }
  }

  render() {
    var invalidKey = this.props.auth.resetPWBadKey;
    var validKey = !invalidKey && this.props.auth.resetPWUser;
    if (validKey) {
      return (
        <div className="authentication-wrapper form-reset-password-page">
          <div className="authentication__card box--shadow  bg--white text--center">
            <Link to="/">
              <img src="/src/assets/icons/senzolive-software-logo.svg" className="authentication__card__logo" />
            </Link>
            <h2 className="authentication__card__welcome-message">Welcome to Senzo Live!</h2>
            <div className="authentication__card__form-wrapper">
              <h3>Reset Password</h3>
              <form>
                <br />
                <input type="username" value={this.props.auth.resetPWUser.username} disabled />
                <input type="email" value={this.props.auth.resetPWUser.email} disabled />
                <input type="password" id="new" placeholder="New Password" className={this.state["newError"] ? "has-error" : ""} onKeyDown={this.handleKeyDown.bind(this)} onChange={this.handleChange.bind(this)} required />
                <input type="password" id="new2" placeholder="Retype Password" className={this.state["new2Error"] ? "has-error" : ""} onKeyDown={this.handleKeyDown.bind(this)} onChange={this.handleChange.bind(this)} required />
                <br />
                <input className="btn-small form__authentication-btn" type="button" name="user_submit" value="Reset Password" onClick={this.submit} />
              </form>
            </div>
          </div>
        </div>
      );
    } else if (invalidKey) {
      return (
        <React.Fragment>
          <div className="app_container">
            <header className="header">
              <div className="header-items">
                <div className="header-items__logo display--flex__flex--center cursor--pointer">
                  <Link to="/">
                    <img src="/src/assets/icons/senzolive-software-logo.svg" />
                  </Link>
                </div>
              </div>
            </header>
          </div>

          <div className="app__content">
            <div className="page-content page-content_padding-modifier">
              <div className="display--flex__flex--center">
                <div className="box--shadow bg--white reset--pwd--wrapper text--center " style={{ padding: "30px" }}>
                  <p style={{ margin: 0, fontSize: "18px" }}>
                    It seems that this link has expired or invalid.
                  </p>
                  <p style={{ margin: 0, fontSize: "18px" }}>
                    Please make another password resetting request.
                  </p>
                  <div className='forgot-password' >
                    <Link to='/forgot'> Request here</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      );
    } else {
      // Loading...
      return null;
    }
  }

  checkForm(data) {
    var ok = true;
    var badKeys = {};
    Object.keys(data).map((key) => {
      if (data[key] === "") {
        badKeys[key + "Error"] = true;
        ok = false;
      } else {
        badKeys[key + "Error"] = false;
      }
    });
    if (data.new != data.new2) {
      badKeys["new2" + "Error"] = true;
    }
    this.setState(badKeys);
  }

  submit() {
    this.checkForm({
      new: this.state.new,
      new2: this.state.new2
    })
    if (this.state.new == "") {
      toastr.error("Please provide new password.");
    } else if (this.state.new != this.state.new2) {
      toastr.error("Password doesn't match.")
    } else {
      var key = this.props.location.query.k;
      this.props.dispatch(resetPassword(key, this.props.auth.resetPWUser.username, this.state.new));
    }
  }
}

function mapStateToProps(state) {
  return {
    auth: state.authReducer
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/containers/resetpassword.jsx